import type {ComponentExportStructure, CoreExportFormat} from '@wix/document-services-types'
import type {DecorationPluginFunction, DecorationPluginUtils} from '../../types'
import _ from 'lodash'

const getNickname = (component: ComponentExportStructure, {nicknameGenerator}: DecorationPluginUtils): string => {
    let nickname = nicknameGenerator.getNickname(component.id)
    if (nickname) {
        return nickname
    }

    nickname = nicknameGenerator.generateNickname(component.id, {
        prefix: component.type.charAt(0).toLowerCase() + component.type.slice(1)
    })
    return nickname
}

const packSingleComponent = (
    rootExport: CoreExportFormat,
    component: ComponentExportStructure,
    {nicknameGenerator}: DecorationPluginUtils
) => {
    const newComponent = _.cloneDeep(component)
    newComponent.id = getNickname(component, {nicknameGenerator})

    if (component.components) {
        newComponent.components = component.components.map((childId: string) => {
            const nickname = getNickname(rootExport.components[childId], {nicknameGenerator})
            return nickname
        })
    }

    return newComponent
}

export const pack: DecorationPluginFunction = (componentExport: CoreExportFormat, {nicknameGenerator}) => {
    const newComponents = _.reduce(
        componentExport.components,
        (acc, component) => {
            const packedComponent = packSingleComponent(componentExport, component, {nicknameGenerator})
            acc[packedComponent.id] = packedComponent
            if (component.id === componentExport.rootComponent) {
                componentExport.rootComponent = packedComponent.id
            }
            return acc
        },
        {} as Record<string, ComponentExportStructure>
    )

    componentExport.components = newComponents
}
